import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { usePlaidLink } from 'react-plaid-link';

import './LinkBank.scss';
import { callApi, getEndpoint } from '../../../utils/api';
import { getBankAccounts } from '../../../redux/modules/linkedBanks/linkedBanks.module';
import { TECHNICAL_BANK_FAILURE, STEP_LANDING } from '../AddBank/AddBank';
import { dispatchPageLoad } from '../../../redux/utils/analytics-helper';

const OauthRedirect = (props) => {
  useEffect(() => {
    dispatchPageLoad('ThirdPartyPlaid');
  }, []);
  const { setBankProgress, setUserPath } = props;
  let onSuccessHappened = false;
  const isOAuthRedirect = window.location.href.includes('?oauth_state_id=');
  const consumer = { bu: 'RETAIL', name: 'SSJ' };
  const [token, setToken] = useState(null);
  let authId = isOAuthRedirect ? window.localStorage.getItem('authId') : null;
  const dispatch = useDispatch();
  const onSuccess = (token, metadata) => {
    const payload = {
      authenticationId: authId,
      metadata,
      public_token: token,
      consumer: { ...consumer },
    };
    onSuccessHappened = true;
    if (authId) {
      dispatch(getBankAccounts(payload));
    } else {
      setBankProgress(TECHNICAL_BANK_FAILURE);
    }
  };

  const onExit = (err) => {
    if (err) {
      setBankProgress(TECHNICAL_BANK_FAILURE);
    } else if (!onSuccessHappened) {
      setBankProgress(STEP_LANDING);
    }
  };

  const onEvent = (eventName, metadata) => {
    const filteredMetaData = {
      timestamp: metadata.timestamp,
      exit_status: metadata.exit_status,
      institution_id: metadata.institution_id,
      institution_name: metadata.institution_name,
      institution_search_query: metadata.institution_search_query,
      link_session_id: metadata.link_session_id,
      mfa_type: metadata.mfa_type,
      view_name: metadata.view_name,
      request_id: metadata.request_id,
      error_code: metadata.error_code,
      error_type: metadata.error_type,
      error_message: metadata.error_message,
      timestamp_epoch_sec: metadata.timestamp_epoch_sec,
    };

    const payload = {
      authenticationId: authId,
      metadata: filteredMetaData,
      eventName,
      consumer: { ...consumer },
    };
    const options = {
      method: 'POST',
    };
    if (authId) {
      callApi(
        getEndpoint('plaidBankingOnEvent'),
        options,
        JSON.stringify(payload)
      )
        .then(() => {})
        .catch((e) => {
          console.log('failed', e);
        });
    }
  };

  const onLoad = () => {
    if (!isOAuthRedirect) {
      callApi(getEndpoint('plaidBankingOnLoad'))
        .then((response) => {
          authId = response?.body?.authenticationId;
          window.localStorage.setItem(
            'authId',
            response?.body?.authenticationId
          );
        })
        .catch((e) => {
          console.log('failed', e);
        });
    }
  };

  const config = {
    token: token,
    linkCustomizationName: 'ssj_stage',
    onSuccess,
    onExit,
    onEvent,
    onLoad,
  };
  if (isOAuthRedirect) {
    config.receivedRedirectUri = window.location.href;
  }
  const { open, ready } = usePlaidLink(config);

  // automatically reinitialize Link or pull from storage
  useEffect(() => {
    if (isOAuthRedirect) {
      setToken(window.localStorage.getItem('link_token'));
      return;
    }
    const body = {
      clientUserId: 'temp',
      redirectUri: `${window.location.origin}/usis/transactions/addbank`,
    };
    const options = {
      method: 'POST',
    };
    callApi(getEndpoint('plaidBankingConfig'), options, JSON.stringify(body))
      .then((response) => {
        setToken(response?.body?.plaidLinkTokenCreateResponse?.link_token);
        window.localStorage.setItem(
          'link_token',
          response?.body?.plaidLinkTokenCreateResponse?.link_token
        );
      })
      .catch((e) => {
        console.log('failed', e);
        setBankProgress(TECHNICAL_BANK_FAILURE);
      });
  }, [isOAuthRedirect, setBankProgress]);

  useEffect(() => {
    // If OAuth redirect, instantly open link when it is ready instead of
    // making user click the button
    if (ready) {
      open();
    }
  }, [ready, open]);

  //resets user to LinkBankPath if user hits the linkBank path
  useEffect(() => {
    setUserPath('LINK');
  }, [setUserPath]);
  return <></>;
};
export default OauthRedirect;
